import { createFileRoute } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import { about } from '~/data/about';
import { langStore } from '~/store/langStore';
import { MarkdownBlock } from '~/utils/markdown';

export const Route = createFileRoute('/about/')({
  component: RouteComponent,
});

function RouteComponent() {
  const locale = useStore(langStore, s => s);

  return (
    <div className="mx-auto flex w-[90%] flex-col gap-2 py-20 text-blackish xl:w-2/3">
      {about[locale].map((item, index) => (
        <div key={index} className="mb-10">
          <MarkdownBlock>
            {item.title}
          </MarkdownBlock>
          <div className="border-2 border-orange p-5 md:p-10">

            <MarkdownBlock>
              {item.text}
            </MarkdownBlock>
          </div>
        </div>
      ))}

    </div>
  );
}
